import { render } from "./FlowyMainMenu.vue?vue&type=template&id=53eea8cc"
import script from "./FlowyMainMenu.vue?vue&type=script&lang=js"
export * from "./FlowyMainMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__